import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";


// redux
import { useDispatch } from "react-redux";
import { Col, Container, Row } from 'reactstrap';
import { setBreadcrumb } from "../../../store/actions";
import EmailSidebar from '../EmailSidebar';
import Inbox from './Inbox';

const EmailInbox = () => {
    const dispatch = useDispatch();
    /*
    set breadcrumbs
    */
    useEffect(() => {
        const breadCrumbItems = {
            title: "Inbox",
        };
        dispatch(setBreadcrumb(breadCrumbItems));
    }, [dispatch]);

    return (
        <React.Fragment>
            <Helmet>
                <title>Inbox | Borex - React Admin & Dashboard Template</title>
            </Helmet>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <EmailSidebar />
                            <Inbox />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default EmailInbox;